import log from 'ws-scripts/modules/logger';

/**
 * Converts time string to minutes for easy comparison
 * @param {string} timeStr - Time in format "9:00AM" or "5PM"
 * @returns {number} - Time in minutes from midnight
 */
export const timeToMinutes = (timeStr) => {
	if (!timeStr) return 0;
	// Extract hour, optional minute, and AM/PM (supports "5PM" and "5:00PM")
	const match = timeStr.trim().match(/^(\d{1,2})(?::(\d{2}))?(AM|PM|am|pm)$/);
	if (!match) {
		log.warn(
			'[ws-locations-search] timeToMinutes: unrecognized time format:',
			timeStr
		);
		return 0;
	}

	// eslint-disable-next-line prefer-const
	let [, hour, minute, period] = match;
	hour = parseInt(hour, 10);
	minute = minute ? parseInt(minute, 10) : 0;

	// Convert to 24-hour format
	if (period.toLowerCase() === 'am' && hour === 12) {
		hour = 0;
	} else if (period.toLowerCase() === 'pm' && hour !== 12) {
		hour += 12;
	}

	return hour * 60 + minute;
};
